(() => {
  // This planner only proposes cart changes. Shopify alone decides whether a gift is free.
  function plan(cart, config, declined = false) {
    const eligibleIds = new Set(config.eligibleIds.map(String));
    const gifts = cart.items.filter(item => item.properties?._welvet_gift === config.campaign && Number(item.variant_id) === config.variantId);
    const subtotal = cart.items.reduce((sum, item) => sum + (eligibleIds.has(String(item.product_id)) && !item.gift_card ? item.final_line_price : 0), 0);
    const eligible = config.enabled && config.available && cart.currency === 'EUR' && subtotal >= config.threshold;
    const paidGift = cart.items.some(item => Number(item.variant_id) === config.variantId && item.properties?._welvet_gift !== config.campaign && item.final_line_price === 0);
    let action = null;
    if (gifts.length && (!eligible || declined || paidGift || gifts.length > 1)) action = {id:gifts[gifts.length - 1].key, quantity:0};
    else if (gifts[0]?.quantity > 1) action = {id:gifts[0].key, quantity:1};
    else if (eligible && !declined && !gifts.length && !paidGift) action = {add:true};
    return {subtotal, eligible, gifts, action};
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = {plan}; return; }
  const element = document.getElementById('WelvetPromoConfig');
  if (!element) return;
  const config = JSON.parse(element.textContent);
  const root = () => window.Shopify?.routes?.root || '/';
  const storageKey = 'welvet-gift-declined-' + config.campaign;
  let declined = false, pending;
  try { declined = sessionStorage.getItem(storageKey) === '1'; } catch {}
  function setDeclined(value) { declined=value; try{sessionStorage.setItem(storageKey,value?'1':'0');}catch{} }
  async function request(path, data) {
    const response = await fetch(root() + path, {cache:'no-store', headers:{Accept:'application/json', ...(data?{'Content-Type':'application/json'}:{})}, ...(data?{method:'POST',body:JSON.stringify(data)}:{})});
    if (!response.ok) throw new Error(config.error);
    return response.json();
  }
  async function reconcile() {
    let cart = await request('cart.js');
    if (plan(cart,config).subtotal < config.threshold) setDeclined(false);
    for (let pass=0;pass<10;pass++) {
      const state = plan(cart, config, declined);
      if (!state.action) {
        // Never leave an automatically added cardholder charging its normal price.
        const charged = state.gifts.find(item=>item.final_line_price > 0);
        if (charged) {
          cart = await request('cart/change.js',{id:charged.key,quantity:0});
          setDeclined(true);
          continue;
        }
        return cart;
      }
      if (state.action.add) {
        try {
          await request('cart/add.js',{items:[{id:config.variantId,quantity:1,properties:{_welvet_gift:config.campaign}}]});
        } catch (error) {
          // Check the server after an ambiguous add response before allowing checkout.
          cart = await request('cart.js');
          setDeclined(true);
          continue;
        }
        cart = await request('cart.js');
      } else cart = await request('cart/change.js',state.action);
    }
    throw new Error(config.error);
  }
  window.WelvetGift = {
    sync(){ if(!pending) pending=reconcile().finally(()=>{pending=null;}); return pending; },
    decline(){setDeclined(true);}, restore(){setDeclined(false);},
    paint(){document.querySelectorAll('[data-promo-choice]').forEach(el=>el.hidden=!declined);}
  };
})();
